// extracted by mini-css-extract-plugin
export default {"container":"ChatCreated_container__VBf2B","header":"ChatCreated_header__y9dRv","buttons":"ChatCreated_buttons__rhi8m","buttonSpacer":"ChatCreated_buttonSpacer__BztE7"};